import { useEffect, useState } from "react";
import { isLoggedInVar, serviceId, serviceName } from "../apollo";
import { TopBar } from "../components/topBar";
import mainPageImage from "../assets/images/mainPageImage.png";
import eventIcon from "../assets/icons/eventIcon.svg";
import chicken from "../assets/icons/chicken.png";
import pizza from "../assets/icons/pizza.png";
import cafe from "../assets/icons/cafe_dessert.png";
import convenience from "../assets/icons/convenience_store.png";
import tteokbokki from "../assets/icons/tteokbokki.png";
import tools from "../assets/icons/tools.png";
import daily from "../assets/icons/daily_items.png";
import korean_food from "../assets/icons/korean_food.png";
import burger from "../assets/icons/burger.png";
import { FootMenu } from "../components/FootMenu";
import { Footer } from "../components/footer";
import { Banner } from "../components/slideBanner";
import { useReactiveVar } from "@apollo/client";
import {
  ListCorporationByLocationQuery,
  useListCorporationByLocation,
} from "../hooks/useListCorporationByLocation";
import { CorporationByLocation } from "../components/corporations";
import { GetCorporation } from "../hooks/useGetCorporation";
import { useNavigate } from "react-router-dom";

const categoryImageMap: { [key: string]: string } = {
  치킨: chicken,
  피자: pizza,
  "카페·디저트": cafe,
  편의점: convenience,
  분식: tteokbokki,
  공구: tools,
  생활용품: daily,
  한식: korean_food,
  버거: burger,
};
export const Home = () => {
  const navigate = useNavigate();
  const home_serviceName = useReactiveVar(serviceName);
  const home_serviceId = useReactiveVar(serviceId);

  // 업종카테고리
  const [selectedCategory, setSelectedCategory] = useState<string>("전체");
  const [mainCategories, setMainCategories] = useState<
    ListCorporationByLocationQuery["listCorporationByLocation"]["mainCategories"]
  >([]);
  const [initialData, setInitialData] = useState<
    ListCorporationByLocationQuery["listCorporationByLocation"]["corporations"]
  >([]);
  const [filteredData, setFilteredData] = useState<
    ListCorporationByLocationQuery["listCorporationByLocation"]["corporations"]
  >([]);

  const onCompleted = (data: ListCorporationByLocationQuery) => {
    const {
      listCorporationByLocation: { corporations, ok, err, mainCategories },
    } = data;
    console.log(data, "data");
    if (ok) {
      setInitialData(corporations);
      setFilteredData(corporations);
      setMainCategories(mainCategories);
    }
  };

  const [listCorporationByLocation] = useListCorporationByLocation(onCompleted);
  const listCorporationByLocationHandler = () => {
    listCorporationByLocation({
      variables: { input: { serviceId: home_serviceId } },
    });
  };

  useEffect(() => {
    if (home_serviceId > 0) {
      listCorporationByLocationHandler();
    }
  }, [home_serviceId]);
  useEffect(() => {
    // "전체" 카테고리가 선택된 경우, 필터링 없이 원본 데이터를 그대로 보여줍니다.
    if (selectedCategory === "전체") {
      setFilteredData(initialData);
      return;
    }

    // 선택된 카테고리에 해당하는 거래처만 필터링합니다.
    const newFilteredData = initialData.filter((corporation) =>
      // corporation의 mainCategories 배열 안에 선택된 카테고리 이름이 있는지 확인합니다.
      corporation.mainCategories.some((cat) => cat.name === selectedCategory)
    );

    setFilteredData(newFilteredData);
  }, [selectedCategory, initialData]);

  return (
    <div className="overflow-auto h-full removeScroll pb-9 abeezee" id="parent">
      <TopBar
        main={true}
        search={true}
        headingColor={"text-mainIcon"}
        shop={true}
        emart={true}
        location={true}
      />
      <main className="content pb-4 relative">
        <div className="max-w-scrrent-fit w-full aspect-square">
          <Banner serviceName={home_serviceName || ""} />
        </div>
        {/* 카테고리 */}
        <div className="bg-white w-full py-3">
          <div className="grid grid-cols-5 gap-x-2 gap-y-5 px-4">
            {mainCategories &&
              mainCategories.map((category) => (
                <button
                  onClick={() => {
                    if (category.name === selectedCategory) {
                      setSelectedCategory("전체");
                    } else {
                      setSelectedCategory(category.name);
                    }
                  }}
                  key={category.id}
                >
                  <div
                    className={`w-14 h-14 ${
                      category.name === selectedCategory
                        ? "bg-mainIcon"
                        : "bg-lightFont"
                    } rounded-[18px] mx-auto p-1`}
                  >
                    <img
                      src={category.upload?.url || ""}
                      alt={category.name}
                      className="w-full"
                    />
                  </div>
                  <p className="text-xs font-bold text-center">
                    {category.name}
                  </p>
                </button>
              ))}
          </div>
        </div>
        {/* 상품리스트 */}
        <section id="niliveryItems" className="relative pb-5">
          <div className="goods transform">
            <div className="w-full mb-5 ">
              <img
                src={mainPageImage}
                onClick={() => {
                  if (!isLoggedInVar()) {
                    navigate("/join/agree");
                  }
                }}
                className=""
              />
            </div>
            <div className="flex flex-col pl-4 border-b border-gray-200 pb-4">
              <div className="flex gap-x-1 items-center">
                <img
                  src={eventIcon}
                  alt="세일이미지"
                  className="w-[17px] h-[14px]"
                />
                <div className="text-[18px]  font-extrabold">
                  {selectedCategory} 매장
                </div>
              </div>
            </div>
            <div className="goods transform break:grid-cols-1 grid sm:gap-x-4">
              {filteredData &&
                filteredData.length > 0 &&
                filteredData.map(
                  (
                    corporation: GetCorporation["getCorporation"]["corporation"],
                    index: number
                  ) => {
                    return (
                      <div
                        key={`corporation-${index}`}
                        className="overflow-x-auto removeScroll"
                      >
                        <CorporationByLocation {...corporation} />
                      </div>
                    );
                  }
                )}
            </div>
            {(!filteredData || filteredData.length === 0) && (
              <div className="max-w-screen-fit mx-auto px-4 relative pt-4 ">
                <p className="text-center text-large break:text-Xlarge py-10 font-bold">
                  입점 준비중 이에요!
                </p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <FootMenu />
    </div>
  );
};
